/**
 * 模块说明：销售中心-退货管理-教材退货管理
 */
import { Service } from '@/tools'
export class RefundServer<T extends TOrder.Refund> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.Refund}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：新增教材退货
   * /api/order/refund/v1/addRefund
   */
  addRefund = <K extends T['ApiAddRefund']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiAddRefund', data, '操作成功')

  /**
   * 功能：新增查询商品列表
   * /api/order/refund/v1/selectProductAddList
   */
  selectProductAddList = <K extends T['ApiSelectProductAddList']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSelectProductAddList', data)

  /**
   * 功能：编辑教材退货
   * /api/order/refund/v1/updateRefund
   */
  updateRefund = <K extends T['ApiUpdateRefund']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateRefund', data, '操作成功')

  /**
   * 功能：分页教材退货列表
   */
  pageRefund = <K extends T['ApiPage']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)

  /**
   * 功能：教材退货单撤销审核
   */
  cancelReview = <K extends T['ApiCancelReview']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiCancelReview', data, '操作成功')

  /**
   * 功能：教材退货单作废
   */
  cancelRefund = <K extends T['ApiCancel']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiCancel', data, '操作成功')

  /**
   * 功能：查看教材退货详情
   */
  detailRefund = <K extends T['ApiDetail']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiDetail', data)

  /**
   * 功能：教材退货商品列表
   */
  productList = <K extends T['ApiProductList']>(data?: K['req']): Promise<K['res']['data']> => this.post2('v1/ApiProductList', data)

  /**
   * 功能：退货商品批次列表
   */
  productBatchList = <K extends T['ApiProductBatchList']>(data?: K['req']): Promise<K['res']['data']> => this.post2('v1/ApiProductBatchList', data)

  /**
   * 功能：教材退货单列表提交审核
   */
  sendReview = <K extends T['ApiSendReview']>(data?: K['req']): Promise<K['res']['data']> => this.post2('v1/ApiSendReview', data, '操作成功')
  /**
   * 功能：教材退货单列表退货审核
   */
  innerCheck = <K extends T['ApiInnerCheck']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiInnerCheck', data, '操作成功')
  /**
   * 功能：教材退货单列表退货审批
   */
  orderApproval = <K extends T['ApiOrderApproval']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiOrderApproval', data, '操作成功')
  /**
   * 功能：教材-实体仓列表
   */
  getWareList = <K extends T['ApiGetWareList']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiGetWareList', data)
}
